import React from 'react';
import { Globe, Shield, FileCheck, HelpCircle } from 'lucide-react';
import './Services.css';

const Services = () => {
  const webPentestDetails = [
    'Authentification, session, contrôle d\'accès (dont IDOR)',
    'Injections & mauvaises configurations',
    'Uploads, protections anti-automation (rate limit / lockout / MFA)',
    'Logique métier (contournements, abus de workflow, élévation de privilèges)'
  ];

  const apiPentestFocus = [
    'Contrôle d\'accès objet & fuite de données',
    'Paramètres, schémas, erreurs, mass assignment',
    'Pagination/filtrage (extraction de données)',
    'Auth (JWT/OAuth), refresh tokens, scopes'
  ];

  const deliverables = [
    'Rapport exécutif (risques, priorités)',
    'Rapport technique (preuves, étapes de reproduction, recommandations)',
    'Option : re-test + call de restitution'
  ];

  const faqItems = [
    {
      question: 'Black box ou grey box ?',
      answer: 'Les deux. Grey box accélère la couverture et améliore la pertinence.'
    },
    {
      question: 'Vous fournissez un rapport ?',
      answer: 'Oui, avec priorisation et recommandations.'
    },
    {
      question: 'Vous testez en prod ?',
      answer: 'Possible selon règles d\'engagement, fenêtre et tolérance au risque.'
    }
  ];

  return (
    <main className="services-page">
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title">Services de Pentest</h1>
          <p className="page-subtitle">
            Tests de sécurité pour applications web et API avec focus sur l'exploitabilité réelle.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="service-detail-card">
            <div className="service-detail-header">
              <Globe size={40} className="service-detail-icon" />
              <div>
                <h2 className="service-detail-title">Pentest Web</h2>
                <p className="service-detail-subtitle">Applications web, back-offices, portails clients, dashboards internes</p>
              </div>
            </div>

            <div className="service-detail-section">
              <h3 className="service-detail-section-title">Ce que vous obtenez</h3>
              <ul className="service-detail-list">
                {deliverables.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>

            <div className="service-detail-section">
              <h3 className="service-detail-section-title">Périmètre typique</h3>
              <ul className="service-detail-list">
                {webPentestDetails.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </div>

          <div className="service-detail-card">
            <div className="service-detail-header">
              <Shield size={40} className="service-detail-icon" />
              <div>
                <h2 className="service-detail-title">Pentest API (REST/GraphQL)</h2>
                <p className="service-detail-subtitle">API publiques/privées, BFF, microservices exposés</p>
              </div>
            </div>

            <div className="service-detail-section">
              <h3 className="service-detail-section-title">Focus</h3>
              <ul className="service-detail-list">
                {apiPentestFocus.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </div>

          <div className="service-detail-card">
            <div className="service-detail-header">
              <FileCheck size={40} className="service-detail-icon" />
              <div>
                <h2 className="service-detail-title">Re-test (option)</h2>
                <p className="service-detail-subtitle">Vérification des correctifs</p>
              </div>
            </div>

            <div className="service-detail-section">
              <p className="service-detail-text">
                Vérification des correctifs et re-priorisation du risque résiduel.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section faq-section">
        <div className="container">
          <div className="faq-header">
            <HelpCircle size={32} className="faq-icon" />
            <h2 className="section-title">Questions fréquentes</h2>
          </div>
          <div className="faq-list">
            {faqItems.map((item, index) => (
              <div key={index} className="faq-item">
                <h3 className="faq-question">{item.question}</h3>
                <p className="faq-answer">{item.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default Services;